export default __webpack_public_path__ + "static/Avenir-Roman-853530f2389c9125680540aad124ff6b.otf";